import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import RoleBasedEntryPoints from './components/RoleBasedEntryPoints';
import MetricsBar from './components/MetricsBar';
import ServicesPreview from './components/ServicesPreview';
import CaseStudyCarousel from './components/CaseStudyCarousel';
import CTASection from './components/CTASection';

const Homepage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('homepage.title')} - SIGNA Technologies</title>
        <meta name="description" content={t('homepage.description')} />
        <meta name="keywords" content="engineering transformation, velocity engineering, ownership culture, architectural modernization, enterprise consulting, CTO, VP Engineering" />
        <meta property="og:title" content={`${t('homepage.title')} - SIGNA Technologies`} />
        <meta property="og:description" content={t('homepage.description')} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${t('homepage.title')} - SIGNA Technologies`} />
        <meta name="twitter:description" content={t('homepage.description')} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <RoleBasedEntryPoints />
          <MetricsBar />
          <ServicesPreview />
          <CaseStudyCarousel />
          <CTASection />
        </main>

        <footer className="bg-primary text-white py-12">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
                    <div className="w-4 h-4 bg-white rounded-sm signal-wave"></div>
                  </div>
                  <div>
                    <span className="text-xl font-bold">SIGNA</span>
                    <span className="text-sm text-gray-400 ml-2">Technologies</span>
                  </div>
                </div>
                <p className="text-gray-300 mb-4 max-w-md">
                  {t('footer.description')}
                </p>
                <div className="text-sm text-gray-400">
                  © {new Date().getFullYear()} SIGNA Technologies. {t('footer.allRightsReserved')}
                </div>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">{t('footer.services')}</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li>{t('footer.velocityEngineering')}</li>
                  <li>{t('footer.ownershipCulture')}</li>
                  <li>{t('footer.architecturalModernization')}</li>
                  <li>{t('footer.enterpriseConsulting')}</li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">{t('footer.company')}</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li>{t('footer.aboutUs')}</li>
                  <li>{t('footer.caseStudies')}</li>
                  <li>{t('footer.knowledgeHub')}</li>
                  <li>{t('footer.contact')}</li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Homepage;